import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import Loading from '@/components/circle-loading'

const ButtonGradientEpic: FC<{
	children: React.ReactNode
	className?: string
	type?: 'button' | 'submit' | 'reset'
	onClick?: (evt: any) => void
	disabled?: boolean
	loading?: boolean
	size?: 'small' | 'medium' | 'large' | 'x-large'
}> = (props): ReactElement => {
	const sizeClasses = {
		'small': 'px-[18px] py-[10px] text-sm',
		'medium': 'px-[20px] py-[12px] text-base',
		'large': 'px-[18px] py-[14px] text-lg',
		'x-large': 'px-[28px] py-[16px] text-xl'
	}

	return (
		<button
			disabled={props.disabled}
			onClick={props?.onClick}
			className={classNames(
				'relative rounded-md bg-gradient-to-r from-purple-600 to-blue-500',
				'hover:from-purple-700 hover:to-blue-600 hover:shadow-lg hover:-translate-y-0.5',
				'transition-all duration-200 ease-in-out select-none',
				'flex items-center justify-center font-semibold text-foreground',
				'disabled:opacity-50 disabled:cursor-not-allowed',
				sizeClasses[props?.size || 'medium'],
				props.className
			)}
			type={props.type || 'button'}
		>
			<div className="relative rounded-md w-full h-full flex items-center justify-center">
				{props?.loading ? <Loading /> : props.children}
			</div>
		</button>
	)
}

export default ButtonGradientEpic
